// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import axios from "axios";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBu4PNLphCHDkEJAA2wxB4vz8S5wDU7Snw",
    authDomain: "ff-arena-notification-server.firebaseapp.com",
    projectId: "ff-arena-notification-server",
    storageBucket: "ff-arena-notification-server.firebasestorage.app",
    messagingSenderId: "275908028770",
    appId: "1:275908028770:web:cd4a96ffa3db9aab67643b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// Generate token and save to backend
// NOTE: This file is for token generation and receiving messages only.
// Sending logic must be pushed to backend controllers.
export const generateToken = async () => {
    console.log("🚀 generateToken function called...");
    try {
        // Check if permission already granted
        if (Notification.permission === 'granted') {

            return await getAndSaveToken();
        }

        // Request permission only if not already decided
        if (Notification.permission === 'default') {
            const permission = await Notification.requestPermission();

            if (permission === "granted") {
                console.log("permission granted")
                return await getAndSaveToken();
            } else {

                return null;
            }
        }


        return null;
    } catch (error) {

        return null;
    }
};

// Helper function to get token and save to backend
async function getAndSaveToken() {
    try {
        console.log("🛠️ Frontend: Waiting for Service Worker...");
        // Wait for service worker to be ready
        const registration = await navigator.serviceWorker.ready;
        console.log("🛠️ Frontend: Service Worker is ready!", registration);

        console.log("🛠️ Frontend: Calling getToken from Firebase...");
        const token = await getToken(messaging, {
            vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration
        });

        if (token) {
            console.log("✅ FCM Token Generated Successfully:", token);

            // Save token to backend
            await saveTokenToBackend(token);
            return token;
        } else {
            console.log("❌ Failed to generate FCM Token - No token returned");
            return null;
        }
    } catch (error) {
        console.error("💥 Frontend: Error in getAndSaveToken:", error);
        return null;
    }
}

// Save token to backend
async function saveTokenToBackend(token) {
    try {
        const response = await axios.post(
            `${backendUrl}/api/save-token`,
            { token },
            { withCredentials: true }
        );

        if (response.data.success) {
            console.log("✅ Frontend: Token saved in DB successfully");
        } else {
            console.log("⚠️ Frontend: Backend responded with success:false", response.data);
        }
    } catch (error) {
        console.error("❌ Frontend: Error saving FCM token to backend:", error.response?.data?.message || error.message);
    }
}